// Re-exports from the hardcoded mapping in activityPlusEmoticonKeywordLibrary.json.
// Keep that file in sync with activityPlusEmoticonEmojis (same emojis, same order).
//
import keywordLibrary from './activityPlusEmoticonKeywordLibrary.json';
import { activityPlusEmoticonEmojis } from './activityPlusEmoticonEmojis';

function cloneEntry(e) {
  return {
    emoji: e.emoji,
    officialName: e.officialName,
    keywords: [...e.keywords],
  };
}

if (process.env.NODE_ENV === 'development') {
  const n = activityPlusEmoticonEmojis.length;
  if (keywordLibrary.length !== n) {
    console.warn(
      `[activityPlusEmoticon] keyword library has ${keywordLibrary.length} entries; activityPlusEmoticonEmojis has ${n}.`
    );
  } else {
    for (let i = 0; i < n; i++) {
      if (keywordLibrary[i].emoji !== activityPlusEmoticonEmojis[i]) {
        console.warn(
          `[activityPlusEmoticon] emoji mismatch at index ${i}: library "${keywordLibrary[i].emoji}" vs list "${activityPlusEmoticonEmojis[i]}".`
        );
        break;
      }
    }
  }
}

/** @type {Array<{ emoji: string; officialName: string; keywords: string[] }>} */
export const activityPlusEmoticonKeywordLibrary = keywordLibrary.map(cloneEntry);

export const activityPlusEmoticonKeywordEntries = activityPlusEmoticonKeywordLibrary;

export const activityPlusEmoticonKeywordMap = Object.fromEntries(
  activityPlusEmoticonKeywordEntries.map((e) => [
    e.emoji,
    { officialName: e.officialName, keywords: [...e.keywords] },
  ])
);

export const activityPlusEmoticonEmojisMissingOfficialUnicodeName =
  activityPlusEmoticonKeywordEntries.filter((e) => !e.officialName).map((e) => e.emoji);
